import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { PageTable, Header } from "/src/layouts/page";
import CompanyHttpLogsTable from "../../../logs/components/ApiLogsTable/CompanyHttpLogsTable";

function CompanyHistoryTable(data) {
    const navigate = useNavigate();
    const companyData = data.data;

    useEffect(() => {
        if (!companyData) {
            navigate("/administration/company/list");
        }
    }, [companyData, navigate]);

    return (
        <PageTable>
            <Header title={`Logs History of ${companyData?.name}`}></Header>
            <CompanyHttpLogsTable companyId={companyData?.id} />
        </PageTable>
    );
}

export default CompanyHistoryTable;
